import EditionPage from './EditionPage';

const FTM_2024 = {
  eyebrow: 'Current edition',
  crumb: 'Family Tree Maker 2024',
  title: 'Family Tree Maker 2024 Support',
  lead: 'Installation, activation, upgrades, and sync help for the newest edition of Family Tree Maker on Windows and Mac.',
  overviewTitle: 'The edition that is actively updated',
  overview: [
    'Family Tree Maker 2024 keeps the familiar workspaces long-time users rely on — People, Places, Media, Sources, Publish, and Web Search — while adding compatibility with current versions of Windows and macOS, including Apple silicon Macs.',
    'Trees from older editions open in 2024 and convert automatically. Make a backup in your old version first, and you will always have an untouched copy to fall back on.',
    'Whether you are upgrading, moving to a new computer, or setting up for the very first time, our technicians can take you from download to your first finished family group.',
  ],
  image: '/images/devices.webp',
  imageAlt: 'Family Tree Maker 2024 running on a laptop',
  featuresTitle: 'What’s worth knowing in FTM 2024',
  features: [
    { icon: 'sync', title: 'FamilySync', text: 'Keep your desktop tree and an Ancestry tree matched, editing in whichever place suits you.' },
    { icon: 'cloud', title: 'TreeVault', text: 'An optional online copy of your trees for peace of mind and easy restores.' },
    { icon: 'photo', title: 'Media workspace', text: 'Photos, documents, audio, and video attached to the people they belong to.' },
    { icon: 'pin', title: 'Places & maps', text: 'Standardise place names and see life events plotted on a map.' },
    { icon: 'book', title: 'Charts & books', text: 'Fan charts, descendant charts, reports, and printed family books.' },
    { icon: 'leaf', title: 'Record hints', text: 'Leaf hints suggest records that may match the people in your tree.' },
  ],
  specs: [
    ['Operating system', 'Windows 10 or 11 (64-bit)', 'macOS 11 or later'],
    ['Processor', 'Modern dual-core or better', 'Intel or Apple silicon'],
    ['Memory', '4 GB RAM (8 GB recommended)', '4 GB RAM (8 GB recommended)'],
    ['Disk space', '1 GB plus space for trees & media', '1 GB plus space for trees & media'],
    ['Internet', 'Needed for activation, updates & sync', 'Needed for activation, updates & sync'],
  ],
  issuesTitle: 'FTM 2024 problems we solve',
  issues: [
    ['Installer will not complete on Windows', 'install-family-tree-maker-on-windows'],
    ['macOS blocks the app from opening', 'install-family-tree-maker-on-mac'],
    ['Upgrade key not accepted', 'activation-and-serial-number-problems'],
    ['Sync stuck after upgrading', 'fix-familysync-errors'],
    ['Photos missing after restore', 'relink-missing-media'],
  ],
  faqs: [
    {
      q: 'Will my older trees open in Family Tree Maker 2024?',
      a: 'Yes. FTM 2024 converts trees from earlier editions when you open them. Back up in your old version first so you keep an untouched copy.',
    },
    {
      q: 'Do I need to uninstall my old version first?',
      a: 'No. You can keep both installed while you check your trees in 2024. Removing the old program never deletes your tree files.',
    },
    {
      q: 'Does FTM 2024 run on Apple silicon Macs?',
      a: 'Yes, it is designed for current Macs. Check the publisher’s latest requirements before upgrading to a brand-new macOS release.',
    },
    {
      q: 'How do I check for updates?',
      a: 'Open the Help menu inside Family Tree Maker and choose the option to check for updates. Installing the latest build fixes many crashes and sync problems.',
    },
  ],
  ctaTitle: 'Need a hand with Family Tree Maker 2024?',
};

export default function Ftm2024Page() {
  return <EditionPage edition={FTM_2024} />;
}
